export default {
    shared: {
        NAME: "Shared",
        events: {
            productOpened: {
                name: "Product Opened",
                requiredFields: ["name", "product", "universitySlug"],
            },
            pageViewed: {
                name: "Page Viewed",
                requiredFields: ["prefix"],
            },
            recordingToggled: {
                name: "Recording Toggled",
                requiredFields: [
                    "toggledTo",
                    "accountRole",
                    "universitySlug",
                    "liveEventId",
                    "subProduct",
                ],
            },
            recordingDownloaded: {
                name: "Recording Downloaded",
                requiredFields: [
                    "fileId",
                    "liveEventId",
                    "accountRole",
                    "universitySlug",
                    "subProduct",
                ],
            },
            timesheetViewed: {
                name: "Unidash_Admins_TimeSpent_PageViewed",
                requiredFields: ["universitySlug", "universityName"],
            },
            buddyBroadcast: {
                name: "Buddy Broadcast Sent",
                requiredFields: ["universitySlug", "universityName"],
            },
            timesheetCSVDownload: {
                name: "Timesheet CSV Downloaded",
                requiredFields: ["universitySlug", "universityName"],
            },
            showAmbassadorRepliesEnabled: {
                name: "Toggled On Show Ambassador Replies",
                requiredFields: ["universitySlug", "universityName"],
            },
            insightMessagesDrawerOpened: {
                name: "Opened Insight Messages Drawer",
                requiredFields: ["universitySlug", "universityName"],
            },
            insightCustomDateRangeFilterApplied: {
                name: "Conversation Insights Custom Date Range Filter Applied",
                requiredFields: ["universitySlug", "universityName"],
            },
            insightReportExported: {
                name: "Conversation Insights Report Exported",
                requiredFields: ["universitySlug", "universityName", "isCustomFilter"],
            },
            prospectNextStep: {
                name: "Prospect Next Step",
                requiredFields: ["universitySlug", "universityName", "forStage", "eventType", "actionType"],
            },
            prospectStageViewed: {
                name: "Prospect Stages Time Filter Applied",
                requiredFields: ["universitySlug", "universityName", "timeFilter"],
            },
            prospectStageStatsExport: {
                name: "Prospect Stage Stats Report Exported",
                requiredFields: ["universitySlug", "universityName", "timeFilter"],
            },
            prospectStageReportHovered: {
                name: "Prospect Stage Report Hovered",
                requiredFields: ["universitySlug", "universityName", "forStage"],
            },
            inviteProspectByLink: {
                name: "Invite Prospect via Copy Link",
                requiredFields: ["universitySlug", "universityName"],
            },
            inviteProspectByEmail: {
                name: "Invite Prospect via Email Notification",
                requiredFields: ["universitySlug", "universityName"],
            },
        },
    },
    chat: {
        NAME: "Chat",
        events: {
            adminIntervention: {
                name: "Admin Intervention",
                requiredFields: ["conversationId", "messageCode"],
            },
            conversationManagementSearch: {
                name: "search_conversation_management",
                requiredFields: ["universityAdminId", "pageViewId"],
            },
        },
    },
};
